import { defineMessages } from "react-intl";

export const messages = defineMessages({
  submitButton: {
    id: "verificationCodeField.button.submit",
    defaultMessage: "Verify",
    description: "Button label for verify",
  },
  resendCodeButton: {
    id: "verificationCodeField.button.resendCode",
    defaultMessage: "Resend code",
    description: "Button label for resend code",
  },
});
